import { Cookies } from 'react-cookie';

export const getUserSessionCookie = () => {
  const cookies = new Cookies();
  const userSessionToken = cookies.get('user_session_token');
  if (!userSessionToken) {
    // Force reload to trigger authentication flow
    window.location.reload();
    return null;
  }

  return userSessionToken;
};

export const getSecureCookieOptions = () => {
  const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  return {
    path: '/',
    secure: !isLocalhost && window.location.protocol === 'https:',
    sameSite: 'strict' as const,
    httpOnly: false
  };
};
